import http from '../../integration/HttpService';

const apiUrl = require('../../config').get(process.env.REACT_APP_ENV).apiUrl;
const resourceUtilizationRouter = apiUrl + '/timeSheetManagement/resourceUtilization/'

/**
 * getResourceUtilizations - retirive all resource utilizations
 * @returns {Object}  Object of resource utilizations
 * @param parms
 */
export  function getResourceUtilizations(parms){
    const endPoint = resourceUtilizationRouter + 'getResourceUtilizations';
    return  http.post(endPoint,parms);
}

/**
 * getResourceList - retirive all resources based on search criteria
 * @returns {Object}  Object of resources
 * @param parms
 */
export  function getResourceList(parms){
    const endPoint = resourceUtilizationRouter + 'getResourceList';
    return  http.post(endPoint,parms);
}

/**
 * getAllocationList - retirive all resource allocations based on search criteria
 * @returns {Object}  Object of resource allocations
 * @param parms
 */
export  function getAllocationList(parms){
    const endPoint = resourceUtilizationRouter + 'getAllocationList';
    return  http.post(endPoint,parms);
}

/**
 * getAllProjectsAndCrs - retirive all projects and crs
 * @returns {Object}  Object of projects and crs
 */
export  function getAllProjectsAndCrs(){
    const endPoint = resourceUtilizationRouter + 'getAllProjectsAndCrs';
    return http.get(endPoint);
}

/**
 * updateResourceRequest - update resource allocations after allocation percentage change
 * @returns {Object}  Object of resource allocations
 * @param parms
 */
export  function updateResourceRequest(parms){
    const endPoint = resourceUtilizationRouter + 'updateResourceRequest';
    return  http.post(endPoint, parms);
}

/**
 * getProjectsAndCrData - retirive all PM allocated projects
 * @returns {Object}  Object of projects
 * @param params
 */
export function getProjectsAndCrData(params){
    const endPoint = resourceUtilizationRouter + 'getProjectsAndCrData';
    return http.post(endPoint, params);
}

/**
 * searchDeliveryTrackerRecords - retirive all delivery tracker records
 * @returns {Object}  Object of projects
 * @param params
 */
export function searchDeliveryTrackerRecords(params){
    const endPoint = resourceUtilizationRouter + 'searchDeliveryTrackerRecords';
    return http.post(endPoint, params);
}

